import { render, staticRenderFns } from "./ModalFormComponent.vue?vue&type=template&id=221011d8"
import script from "./ModalFormComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports